const PanelLeftCloseIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 5l-7 7 7 7" fill="none" />
  </svg>
);

export default PanelLeftCloseIcon;
